import React from 'react'

import { theme } from '@components/Theme'

import { Svg } from './Svg'

export interface FlatApartmentsProps {
  color?: string
  hoverColor?: string
  className?: string
  size?: string | number
}

export function FlatApartments({ color= theme.colors.greys.mineshaft, hoverColor, className, size = '100%' }: FlatApartmentsProps): JSX.Element {
  return (
    <Svg
      $strokeColor={color}
      $strokeHoverColor={hoverColor}
      $fillColor={color}
      $fillHoverColor={hoverColor}
      className={className}
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g transform="scale(1.08) translate(-5,-5)">
        <g id="Layer_1">
          <g>
            <path d="M94.4,68.9c0,11.3,0,22.5,0,33.8,0,5.2-2.1,7.3-7.3,7.3-5.9,0-11.9,0-17.8,0-2.9,0-3.9-1.1-3.7-3.9.1-2,0-4.1,0-6.1,0-3.5-.2-3.6-4.7-3.6-6.6,0-6.6,0-6.7,3.4,0,2.1,0,4.3,0,6.4.1,2.6-.9,3.7-3.6,3.7-6-.1-12.1,0-18.1,0-5,0-7.1-2.1-7.1-7.1,0-22.4,0-44.8,0-67.3,0-1.9,0-3.4-2.1-4.5-1-.6-1.8-2.9-1.5-4.2.3-1.3,1.9-2.3,3.2-3.2.6-.4,1.6-.2,2.4-.2,21.7,0,43.4,0,65.1,0,1.7,0,3.7.7,4.9,1.8,1.7,1.5,1.1,4.7-1,5.8-1.8,1-2,2.2-2,3.9,0,11.3,0,22.5,0,33.8ZM44.4,38.9c.5-3-.8-4-3.7-4-2.9,0-3.9,1-4,3.9,0,2.9.9,3.9,3.9,3.9,2.8,0,4.4-.6,3.8-3.7ZM40.5,57.9c2.8.5,4.2-.3,4.1-3.5,0-2.7-.5-4.2-3.7-4.1-2.7,0-4.2.6-4.1,3.7,0,2.6.4,4.6,3.7,3.9ZM40.7,73.2c3.1.7,3.8-.9,3.9-3.7,0-3-1.1-3.8-4-3.9-3,0-3.8,1.2-3.9,4,0,3,1,4.2,4,3.6ZM40.6,88.6c2.8.6,4-.4,4-3.5,0-2.8-.6-4.1-3.8-4.1-2.8,0-4.1.7-4.1,3.8,0,2.7.5,4.5,3.9,3.8ZM59.6,42.5c2.7.5,4.3,0,4.1-3.4-.1-2.5-.2-4.3-3.6-4.2-2.6.1-4.3.4-4.1,3.6.1,2.5,0,4.7,3.6,3.9ZM78.9,42.5c2.9.6,4.1-.5,4-3.5,0-2.7-.7-4.1-3.8-4-2.8,0-4.1.7-4,3.8,0,2.8.6,4.5,3.8,3.8ZM59.9,57.8c3.1.8,3.7-.8,3.8-3.6,0-2.9-.9-3.9-3.9-3.9-3,0-3.9,1-3.9,3.9,0,2.9.8,4.4,4,3.6ZM79,50.4c-3-.5-3.9.9-3.9,3.8,0,3,1,3.8,3.9,3.8,2.9,0,4-.9,3.9-3.8,0-2.8-.8-4.4-3.9-3.8ZM59.7,73.2c2.8.6,4.1-.3,4-3.5,0-2.7-.5-4.2-3.7-4.1-2.7,0-4.2.6-4,3.7.1,2.6.3,4.6,3.7,3.8ZM75.3,69.4c-.5,2.6.2,4.1,3.4,4,2.5-.1,4.4-.2,4.2-3.5-.1-2.5-.3-4.4-3.6-4.2-2.5.1-4.6.2-4,3.7ZM59.7,88.6c3,.6,4-.6,4-3.6,0-2.8-.7-4.1-3.8-4-2.9,0-4,.8-3.9,3.8,0,2.7.5,4.5,3.8,3.7ZM78.9,88.6c2.9.6,4.1-.5,4.1-3.5,0-2.7-.7-4.1-3.8-4.1-2.8,0-4.1.7-4,3.8,0,2.7.5,4.5,3.8,3.8Z" fill={color} />
            <path d="M59.7,18.6c-8.4,0-16.8,0-25.2,0-3.5,0-5.5-1.6-5.4-4.4,0-2.6,2-4.2,5.3-4.2,16.9,0,33.7,0,50.6,0,3.5,0,5.5,1.7,5.5,4.5,0,2.6-2.1,4.1-5.7,4.1-8.4,0-16.8,0-25.2,0Z" fill={color || '#222'} />
          </g>
        </g>
      </g>
    </Svg>
  )
}
